import { useIncomeHistoryFieldBindings } from "@Client/@Composables/application-standalone/pages/income-history/useIncomeHistoryFieldBindings";
import { useIncomeHistoryFieldVisibility } from "@Client/@Composables/application-standalone/pages/income-history/useIncomeHistoryFieldVisibility";
export const incomeHistoryPageBindingsAndVisibilities = (applicantIndex, incomeIndex, applicantId) => {
  const {
    employerName,
    currentJob,
    companyType,
    employmentType,
    grossRevenue,
    incomeAmount,
    incomePeriod,
    incomeType,
    industrySector,
    jobTitle,
    monthsInIndustry,
    occupation,
    operatingAs,
    selfEmployed,
    timeAtJob,
    employmentWorkPhone,
    employmentAddress
  } = useIncomeHistoryFieldBindings({
    applicantIndex,
    employmentIndex: incomeIndex
  });
  const {
    incomeEmployerNameVisible,
    incomeCurrentJobVisible,
    incomeCompanyTypeVisible,
    incomeEmploymentTypeVisible,
    incomeGrossRevenueVisible,
    incomeIncomeAmountVisible,
    incomeIncomePeriodVisible,
    incomeIncomeTypeVisible,
    incomeIndustrySectorVisible,
    incomeJobTitleVisible,
    incomeMonthsInIndustryVisible,
    incomeOccupationVisible,
    incomeOperatingAsVisible,
    incomeSelfEmployedVisible,
    incomeTimeAtJobVisible,
    incomeWorkPhoneVisible,
    incomeAddressVisible
  } = useIncomeHistoryFieldVisibility({
    applicantIndex,
    employmentIndex: incomeIndex,
    applicantId
  });
  return {
    bindings: {
      employerName,
      currentJob,
      companyType,
      employmentType,
      grossRevenue,
      incomeAmount,
      incomePeriod,
      incomeType,
      industrySector,
      jobTitle,
      monthsInIndustry,
      occupation,
      operatingAs,
      selfEmployed,
      timeAtJob,
      employmentWorkPhone,
      employmentAddress
    },
    visibilities: {
      incomeEmployerNameVisible,
      incomeCurrentJobVisible,
      incomeCompanyTypeVisible,
      incomeEmploymentTypeVisible,
      incomeGrossRevenueVisible,
      incomeIncomeAmountVisible,
      incomeIncomePeriodVisible,
      incomeIncomeTypeVisible,
      incomeIndustrySectorVisible,
      incomeJobTitleVisible,
      incomeMonthsInIndustryVisible,
      incomeOccupationVisible,
      incomeOperatingAsVisible,
      incomeSelfEmployedVisible,
      incomeTimeAtJobVisible,
      incomeWorkPhoneVisible,
      incomeAddressVisible
    }
  };
};